import { EndPoints } from "./endpoints";

export class ListToken {
  public static readonly BLACKLIST = [
    EndPoints.LISTS,
    EndPoints.SEARCH,
    EndPoints.LOGIN
  ];
}
